import React, { useState, useEffect, useContext } from 'react';
import IssueStatusService from "../../Controller/IssueStatusDefaultController/IssueStatusController";
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { Link } from "react-router-dom";
import CreateIssueStatus from './CreateIssueStatus';
import BASE_URL from "../../../../config/config";
import HelpSite from "../../../Common/HelpLink";
import Common from '../../../Common/Common';
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
function IssueStatusPage() {
    const navigate = useNavigate();
    const [IssueStatusList, setIssueStatus] = useState([]);
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [modalInstance, setModalInstance] = useState(null);
    const [currentIssue, setCurrentIssue] = useState(null);
    const fetchIssueStatus = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const issueStatusData = await IssueStatusService.GetAllIssueStatus(redirectCallback);
            setIssueStatus(issueStatusData);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };

    useEffect(() => {
        fetchIssueStatus();
    }, []);

    useEffect(() => {
        setModalInstance(new window.bootstrap.Modal(document.getElementById('issueStatusModal')));
    }, []);

    const handleCreateIssueStatusClick = () => {
        setCurrentIssue(null);
        if (modalInstance) {
            modalInstance.show();
        }
    };

    const handleCloseModal = () => {
        if (modalInstance) {
            modalInstance.hide();
        }
    };
    const handleEditClick = (issue) => {
        setCurrentIssue(issue); // Set the team to be edited
        if (modalInstance) {
            modalInstance.show();
        }
    };

    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation();
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await IssueStatusService.DeleteIssueStatus(ID);
                    fetchIssueStatus(); // Refresh the list after deletion
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });
    };
    const handleBaseIssueStatusToggle = async (event,ID) => {
        try {
            event.stopPropagation();
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            await IssueStatusService.SetDefaulIssueStatus(ID);
            fetchIssueStatus();

        } catch (error) {
            console.error('API request failed:', error);
        }
    };
    const handleBaseIssueStatusClosed = async (event,ID) => {
        try {
            event.stopPropagation();
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            await IssueStatusService.SetCloseIssueStatus(ID);
            fetchIssueStatus();

        } catch (error) {
            console.error('API request failed:', error);
        }
    };
    const handleBaseIssueStatusComplete = async (event,ID) => {
        try {
            event.stopPropagation();
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            await IssueStatusService.SetCompleteIssueStatus(ID);
            fetchIssueStatus();

        } catch (error) {
            console.error('API request failed:', error);
        }
    };
    const HelpLink = localStorage.getItem('HelpLink');
    const CompanyID = localStorage.getItem("CompanyID");
    return (
        <div>
            <Common />
            <div className="row mb-3">

                <div className="col-sm-3">

                    <Link className='btn btn-primary btn-sm' onClick={handleCreateIssueStatusClick}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </Link>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <table className="table m-0 table-hover">
                <thead>
                    <tr>

                        <th>Status Name</th>
                        <th>Icon</th>
                        <th>Default</th>
                        <th>Complete</th>
                        <th>Closed</th>
                        <th style={{ "textAlign": "right" }}>Actions</th>
                    </tr>
                </thead><tbody>
                    {IssueStatusList.map((issue, index) => (

                        <tr key={issue.ID} onClick={() => handleEditClick(issue)}
                            style={{
                                cursor: 'pointer',
                            }}>

                            <td>{issue.StatusName}</td>


                            <td>
                                <a href={`${BASE_URL}/uploads/Default/SuperAdmin/StatusDefault/${issue.Icon}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={(event) => event.stopPropagation()}>
                                    <img src={`${BASE_URL}/uploads/Default/SuperAdmin/StatusDefault/${issue.Icon}`}
                                        style={{ width: "20px", height: "20px", cursor: "pointer" }} />
                                </a>
                            </td>
                            <td>
                                <button style={{ "padding": "4px 5px" }}
                                    className={`btn ${issue.IsDefault === 1 ? 'btn btn-primary btn-sm' : 'btn btn-secondary btn-sm'}`}
                                    onClick={(event) => handleBaseIssueStatusToggle(event, issue.ID)}
                                >
                                    {issue.IsDefault === 1 ? 'On' : 'Off'}
                                </button>
                            </td>
                            <td>
                                <button style={{ "padding": "4px 5px" }}
                                    className={`btn ${issue.Complete === 1 ? 'btn btn-success btn-sm' : 'btn btn-secondary btn-sm'}`}
                                    onClick={(event) => handleBaseIssueStatusComplete(event, issue.ID)}
                                >
                                    {issue.Complete === 1 ? 'On' : 'Off'}
                                </button>
                            </td>
                            <td>
                                <button style={{ "padding": "4px 5px" }}
                                    className={`btn ${issue.IsCompleted === 1 ? 'btn btn-danger btn-sm' : 'btn btn-secondary btn-sm'}`}
                                    onClick={(event) => handleBaseIssueStatusClosed(event, issue.ID)}
                                >
                                    {issue.IsCompleted === 1 ? 'On' : 'Off'}
                                </button>
                            </td>







                            <td style={{ "textAlign": "right" }}>


                                <button className="text-danger" style={{ "background": "none", "border": "none" }} onClick={(event) => handleDeleteClick(event, issue.ID)}>
                                    <i className="icofont-ui-delete" aria-hidden="true"></i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <CreateIssueStatus issue={currentIssue} onClose={handleCloseModal} onSuccess={fetchIssueStatus} />
        </div>
    );
}

export default IssueStatusPage;